{
	"resourceType": "Questionnaire",
	"meta": {
		"profile": ["http://hl7.org/fhir/4.0/StructureDefinition/Questionnaire"]
	},
	"url": "http://reference-data.careconnect.be/api/fhir/Questionnaire/TIMED_CHAIR_STAND",
	"name": "TIMED_CHAIR_STAND",
	"language": "fr-BE",
	"status": "active",
	"publisher": "Corilus NV",
	"title": "Timed Chair Stand",
	"purpose": "Mesure la force musculaire et la mobilité fonctionnelle",
	"description": "Mesurer le temps (en secondes) nécessaire pour se lever et s’asseoir cinq fois de suite.",
	"item": [
		{
			"linkId": "573-instructions",
			"text": "Le patient à examiner, bras croisés sur le thorax, est assis sur une chaise avec un dossier et sans accoudoirs. On lui demande de se lever et de s’asseoir cinq fois d’affilée sans l’aide des bras et le plus rapidement possible. L’utilisation d’un moyen d’aide n’est pas autorisée. Un essai pratique est recommandé pour familiariser le patient au test.",
			"type": "display"
		},
		{
			"linkId": "80200",
			"text": "Combien de secondes faut-il pour effectuer le Timed Chair Stand?",
			"type": "integer",
			"required": true,
			"extension": [
				{
					"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-unit",
					"valueCoding": {
						"system": "http://unitsofmeasure.org",
						"code": "s",
						"display": "seconds"
					}
				},
				{
					"url": "http://hl7.org/fhir/StructureDefinition/minValue",
					"valueInteger": 1
				}
			]
		}
	]
}
